import React from "react";
import qs from "qs";
import MasterTemplate from "./MasterTemplate";
import Cleave from "cleave.js/react"
import Axios from 'axios'
var bcrypt = require('bcryptjs')


export class MasterCadastroMonitor extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            monitor: undefined,
            queryString: qs.parse(this.props.location.search, { ignoreQueryPrefix: true }),
            confirmarSenha: '',
            senha: ''
        }
        this.getUser()

        console.log(this.state.queryString)
    }

    async getUser() {
        if (this.state.queryString.id) {
            try {
                var axiosInstance = new Axios.create({
                    baseURL: window.localStorage.getItem("apiUrl")
                })
                const response = await axiosInstance.post("usuarios/user", {
                    id: this.state.queryString.id
                })
                this.setState({ monitor: response.data })
            } catch (err) {
                console.log(err)
            }
        }
    }

    concluirMonitor() {

        if (this.state.senha !== this.state.confirmarSenha) {
            alert('Você deve preencher as senhas corretamente nos campos!')
            return;
        }
        if (!this.state.queryString.id) {
            this.cadastrarMonitor();

        }
        else if (this.state.queryString.id && this.state.senha != '' && this.state.senha == this.state.confirmarSenha) {
            this.atualizarMonitor();
        }
        else if (this.state.queryString.id && this.state.senha == '') {
            this.atualizarMonitorSemPassword();
        }
    }

    async cadastrarMonitor() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            })
            const salt = await bcrypt.genSalt()
            const hash = await bcrypt.hash(this.state.senha, salt)
            const response = await axiosInstance.post("usuarios/cadastrar-monitor", { ...this.state.monitor, senha: hash, tutorId: this.state.user._id })
            console.log(response.data)
            // window.location.href = '/master-gerenciar-monitores';
        } catch (err) {
            console.log(err)
        }
    }
    async atualizarMonitor() {

        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            })
            const salt = await bcrypt.genSalt()
            const hash = await bcrypt.hash(this.state.senha, salt)
            const response = await axiosInstance.post("usuarios/update-one-user", { ...this.state.monitor, senha: hash })
            window.location.href = '/master-gerenciar-monitores';
        } catch (err) {
            console.log(err)
        }
    }

    async atualizarMonitorSemPassword() {
        delete this.state.monitor['senha']
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            })
            const response = await axiosInstance.post("usuarios/update-one-user", { ...this.state.monitor })
            window.location.href = '/master-gerenciar-monitores';
        } catch (err) {
            console.log(err)
        }
    }

    handleInputChange(event) {
        const { name, value } = event.target
        if (name == 'confirmarSenha') {
            this.setState({ confirmarSenha: value })

        }
        else if (name == 'senha') {
            this.setState({ senha: value })

        }
        else {
            if (this.state.monitor == undefined)
                this.state.monitor = { [name]: value }

            this.state.monitor[name] = value;
            this.setState({ monitor: this.state.monitor })
        }
    }

    render() {
        return (
            <MasterTemplate label="Cadastrar Monitor">
                <div className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-12 col-lg-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-title">Cadastro de Monitor</h4>
                                    </div>
                                    <div className="card-body">
                                        <input className="form-control" onChange={this.handleInputChange.bind(this)} name="nome" placeholder="Nome" value={this.state.monitor?.nome}></input>
                                        <Cleave
                                            onChange={this.handleInputChange.bind(this)} name="cpf" placeholder="CPF" data-length="11"
                                            value={this.state.monitor?.cpf}
                                            className={`form-control mt-3`}
                                            options={{
                                                numericOnly: true,
                                                delimiters: ['.', '.', '-'],
                                                blocks: [3, 3, 3, 2]
                                            }}
                                        />
                                        <Cleave onChange={this.handleInputChange.bind(this)} name="telefone"
                                            value={this.state.monitor?.telefone}
                                            placeholder="Telefone"
                                            data-length="10"
                                            className="form-control mt-3"
                                            options={{
                                                phone: true,
                                                phoneRegionCode: 'BR'
                                            }}
                                        />
                                        <input className="form-control mt-3" onChange={this.handleInputChange.bind(this)} placeholder="E-mail" name="email" value={this.state.monitor?.email}></input>
                                        <select id="status" onChange={this.handleInputChange.bind(this)} name="status"
                                            className="form-control custom-select mt-3"
                                            style={{ height: 'calc(2.25rem + 4px)' }}>
                                            <option value={this.state.monitor?.status ? 'Ativo' : 'Bloqueado'}>{this.state.monitor?.status ? 'Ativo' : 'Bloqueado'}</option>
                                            <option value="true">Ativo</option>
                                            <option value="false">Bloqueado</option>
                                        </select>
                                        <div className="d-flex mt-3">
                                            <input className="form-control" onChange={this.handleInputChange.bind(this)} name="senha" type="password" placeholder="Senha"></input>
                                            <input className="form-control ml-5" type="password" onChange={this.handleInputChange.bind(this)} name="confirmarSenha" placeholder="Confirmar senha"></input>
                                        </div>
                                        <button className="mt-3 btn-fill btn btn-success" onClick={this.concluirMonitor.bind(this)}>Concluir</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MasterTemplate>
        );
    }
}

export default MasterCadastroMonitor;
